import { albumResolutionDetail } from './library.ts';
import type { AlbumSummary } from '../types';

export const SITE_URL = 'https://flac.banast.as';

export function albumDescription(album: AlbumSummary): string {
  const detail = albumResolutionDetail(album);
  const formats = album.formats.join(' / ');
  const tracks = `${album.trackCount.toLocaleString('en-US')} ${album.trackCount === 1 ? 'track' : 'tracks'}`;
  return `${album.artist} — ${album.title}${album.year ? ` (${album.year})` : ''}. ${tracks}${formats ? ` in ${formats}` : ''}${detail ? `, ${detail}` : ''}.`;
}

// schema.org dates must be ISO 8601; legacy ranges such as "1957-2013" fall back to the year.
export function schemaDate(album: Pick<AlbumSummary, 'releaseDate' | 'year'>): string | null {
  if (album.releaseDate && /^\d{4}(?:-\d{2}(?:-\d{2})?)?$/.test(album.releaseDate)) return album.releaseDate;
  return album.year ? String(album.year) : null;
}

export function albumJsonLd(album: AlbumSummary, url: string): Record<string, unknown> {
  const jsonLd: Record<string, unknown> = {
    '@context': 'https://schema.org',
    '@type': 'MusicAlbum',
    '@id': url,
    url,
    name: album.title,
    byArtist: { '@type': 'MusicGroup', name: album.artist },
    numTracks: album.trackCount,
  };
  const date = schemaDate(album);
  if (date) jsonLd.datePublished = date;
  if (album.genres.length) jsonLd.genre = album.genres;
  if (album.label) jsonLd.recordLabel = { '@type': 'Organization', name: album.label };
  if (album.cover) jsonLd.image = `${SITE_URL}${album.cover}`;
  return jsonLd;
}
